export default "__VITE_ASSET__DMYLPunQ__"